.root {
  .container {
    font-size: 12px;
    line-height: 1;
    padding: 10px;
  }
}
